import { Navigation } from "@/components/public/layout/Navigation"
import Gallery from "@/components/public/Gallery"
import { Footer } from "@/components/public/layout/Footer"
import FloatingMenu from "@/components/public/FloatingMenu"

export default function GalleryPage() {
    return (
        <div className="min-h-screen bg-background dark:bg-gray-900">
            <Navigation />
            <Gallery />
            <Footer />
            <FloatingMenu />
        </div>
    )
}
